'use strict';

import template from './suspended.html';

function controller($state, $window, $document, $rootScope, $element, activateGuideAccount, navigation, userModel, throttle, settings) {
  'ngInject';

  if (!userModel.item.isSuspended) {
    window.location.replace('/');
  }

  // hide navigation and footer
  const navigationEl = navigation.getElement();
  const footerEl = document.getElementsByClassName('Footer')[0];
  const hideNavAndFooter = () => {
    navigationEl.css('display', 'none');
    footerEl.style.display = 'none';
  };

  hideNavAndFooter();
}

const saSuspended = [
  function () {
    return {
      template: template,
      replace: true,
      scope: {
        done: '&',
      },
      bindToController: true,
      controllerAs: 'ctrl',
      controller: controller
    };
  }
];

export default saSuspended;



// WEBPACK FOOTER //
// ./app/src/directives/suspended.js